<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">排班</h3>
      <div class="content">
        <div class="item">
          <p>已排班管家</p>
          <template v-for="item in planList">
            <a :class="['plan-item',{'btn-primary2':item.checked}]" @click.stop="clickPlan(item)">
              <div class="name">{{item.scheduleConfigName}}</div>
              <div class="list-wrapper">
                <a :class="['zo-button',{'btn-primary2':item.checked}]"
                   v-for="(item1,index1) in item.scheduleZoList" @click.stop="clickAready(item1,index1,item)">
                  {{item1.text}}
                </a>
              </div>
            </a>
          </template>
        </div>
        <div class="item">
          <p>未排班管家</p>
          <div class="plan-item list-wrapper">
            <a class="zo-button" v-for="(item,index) in GOList" @click="clickGO(item,index)">{{item.text}}
            </a>
            <!--<Button class="un-plan"></Button>-->
            <!--<Button class="un-plan"></Button>-->
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {deepClone} from "../../../../../utils/format";
  import {updateSchedule} from 'api/scheduleManage.js'

  export default {
    // name: "PaiBanModal"
    props: {
      n: {
        type: Number,
        default: 0
      },
      planListOri: {
        type: Array,
        default: null
      },
      GOListOri: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        isShow: false,
        planList: null,
        loading: false,
        GOList: null
        // a:true
      }
    },
    watch: {
      n() {
        this.planList = deepClone(this.planListOri)
        this.GOList = deepClone(this.GOListOri)
        this.isShow = true
      },
      planListOri(value) {
        this.planList = deepClone(value)
      },
      GOListOri(value) {
        this.GOList = deepClone(value)
      }
    },
    computed: {
      checkedOne() {
        if (this.planList == null) {
          return []
        }
        return this.planList.filter(ele => {
          return ele.checked
        })
      }
    },
    methods: {
      cancel() {
      },
      ok() {
        this.$emit('updateSchedule', this.planList)
      },
      clickAready(item1, index1, item) {
        // if (this.checkedOne.length == 0 || this.checkedOne[0].scheduleConfigFid !== item.scheduleConfigFid) {
        //   return
        // }
        // if (this.checkedOne[0].scheduleConfigFid !== item.scheduleConfigFid) {
        //   return
        // }
        item.scheduleZoList.splice(index1, 1)
        this.GOList.push(item1)
      },
      clickGO(item, index) {
        if (this.checkedOne.length == 0) {
          if(this.planList.length==1){
            this.planList[0].checked=true
          }
          else {
            this.$Message.info('请先选择班次')
            return
          }
        }
        this.GOList.splice(index, 1)
        if (this.checkedOne[0].scheduleZoList === null) {
          this.checkedOne[0].scheduleZoList=[]
        }
        this.checkedOne[0].scheduleZoList.push(item)
      },
      clickPlan(item) {
        this.planList.forEach(ele => {
          ele.checked = false
        })
        item.checked = !item.checked
      },
    }
  }
</script>

<style scoped>
  .un-wrapper {
    min-height: 60px;
  }

  .zo-button {
    color: black;
    display: inline-block;
    padding: 0 10px;
    line-height: 2;
    width: 70px;
  }

  .plan-item {
    color: black;
    display: block;
    width: 100%;
    margin: 10px auto 0 auto;
    min-height: 60px;
    padding: 15px;
    border: 1px solid rgb(220, 220, 220);
    text-align: left;
  }

  .plan-item:first-child {
    margin-top: 0;
  }

  .border {
    border: 1px solid rgb(220, 220, 220);
    margin-top: 10px;
  }

  .name {
    text-align: left;
    color: black;
  }

  .item {
    width: 200px;
    text-align: center;
  }

  .content {
    display: flex;
    justify-content: space-around;
  }

</style>
